import { Card, CardBody } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import { CustomRowRender } from "ui/grid/CustomGrid";
import style from "./style.module.css";
import styles from "styles.module.css";
import { ICON_NAMES } from "utils/constant";
import { addMonths, addYears } from "date-fns";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { TextButton } from "ui/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import { gridColumnFrontItemsHandler } from "component/pages/landingNote/utils/GridColumns";
import { getLandingNotesApi, importLandingNote } from "api/landingNote";
import { ILandingNote } from "interface/landingNote";
import { lastColWithBtn } from "ui/grid/lastColumnts";
import Loading from "ui/Loading";
import { useHomePageAccessStore, useUserOrganizationsStore } from "store";
import { GrideDateFormatter } from "ui/Date";

const statusColor = (status: number, signStatus?: number) => {
	if (status === 1) return "#D64545";
	if (status === 2) return "#e6bf00";
	if (status === 4 && signStatus === 0) return "#f28c28";
	return "#2b8e61";
};

function LandingNoteCard({ isMobileView = false }: { isMobileView?: boolean }) {
	const { t } = useTranslation();
	const [gridData, setGridData] = useState<ILandingNote[]>();
	const navigate = useNavigate();
	const { defaultOrg } = useUserOrganizationsStore();

	const { homePageAccess } = useHomePageAccessStore();
	const router = useNavigate();
	const fileInputRef = useRef<HTMLInputElement>(null);
	const noteRef = useRef<ILandingNote | null>(null);
	const overlayRef = useRef<HTMLDivElement>(null);

	const [forceUpdate, setForceUpdate] = useState(false);


	useEffect(() => {
		if (!homePageAccess?.landingNote || !homePageAccess.landingNote.read)
			return;
		getLandingNotesApi({
			take: 3,
			skip: 0,
			fromDate: addYears(new Date(), -1),
			toDate: new Date(),
			terminalCode: defaultOrg?.id as unknown as string,
			vesselId: defaultOrg?.vesselId,
		})
			.then((response) => {
				setGridData(response.data);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [homePageAccess?.landingNote, defaultOrg]);

	const openEdit = (props: GridCellProps) => {
		if (props.dataItem.noteStatusId === 4) {
			router(`/${PageTypePath.Signature}/${props.dataItem.noteNumber}`, {
				state: {
					noteType: 1, // 0  for sales note 1 for landing note
					quotaTypeCode: props.dataItem.quotaTypeCode,
				},
			});
			return;
		}
		router(`/${PageTypePath.LandingNoteForm}/${props.dataItem.noteNumber}/0`);
		// window.open(
		// 	`/${PageTypePath.LandingNoteForm}/${prop.dataItem.noteNumber}/0`
		// );
	};

	const openPdf = (prop: GridCellProps) => {
		localStorage.setItem("noteNumber", prop.dataItem.noteNumber);
		localStorage.setItem("pdfType", "LandingNote");

		window.open(`/${PageTypePath.Pdf}/${prop.dataItem.reportGuid}`, "_blank");
	};

	const openEditByItem = (item: ILandingNote & Record<string, any>) => {
		if (item.noteStatusId === 4) {
			navigate(`/${PageTypePath.Signature}/${item.noteNumber}`, {
				state: {
					quotaTypeCode: item.quotaTypeCode,
					noteType: 1,
				},
			});
			return;
		}

		const step = item.currentStep;
		navigate(`/${PageTypePath.LandingNoteForm}/${item.noteNumber}/${step}`);
	};

	const upload = (prop: GridCellProps) => {
		noteRef.current = prop.dataItem;
		fileInputRef.current?.click();
	};
	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		const note = noteRef.current;
		if (!file || note === null) return;

		if (overlayRef.current) overlayRef.current.style.display = "block";

		importLandingNote(file, note.noteNumber as unknown as number)
			.finally(() => {
				if (overlayRef.current) overlayRef.current.style.display = "none";
				if (fileInputRef.current) fileInputRef.current.value = "";
				setForceUpdate((prev) => !prev);
			})
			.then((response) => {
				openEditByItem(note);
				noteRef.current = null;
			});
	};


	const pageAccess = homePageAccess?.landingNote;
	if (!pageAccess) {
		return <Loading show={true} />;
	}

	return (
		<div>
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: "none" }}
				onChange={handleFileChange}
			/>
			<Card
				//className={style.CardItem}
				className={"home-card-item"}
			>
				<CardBody>
					<div className={`${styles.BoxHeadingMedium} ${style.CardBodyHeader}`}>
						<div>{t("LastLandingNotes")}</div>
						<div>
							<TextButton
								text={t("OverViewLandingNotes")}
								onClick={() => navigate(`/${PageTypePath.LandingNoteList}`)}
								iconName={ICON_NAMES.Arrow}
							/>
						</div>
					</div>
					<div>
						{isMobileView ? (
							<div>
								{(gridData || []).map((item, index) => {
									const showEdit =
										pageAccess?.update &&
										(item.noteStatusId === 1 || item.noteStatusId === 2);
									const showSignature =
										pageAccess?.update && item.noteStatusId === 4;

									return (
										<div
											key={`${item.noteNumber}-${index}`}
											className="home-mobile-list-item"
										>
											<div
												style={{
													width: 10,
													height: 10,
													borderRadius: "50%",
													backgroundColor: statusColor(
														item.noteStatusId,
														item.signStatus,
													),
												}}
											/>
											<div className="home-mobile-list-item-main">
												<div className="home-mobile-list-item-value">
													{item.noteNumber}
												</div>
												<div className="home-mobile-list-item-label">
													<GrideDateFormatter
														date={item.landingTime}
														formatType="dd.MM.yyyy"
														noTd={true}
													/>
												</div>
											</div>
											<div className="home-mobile-list-item-secondary">
												{item.netLiveWeightKg || 0} kg
											</div>
											<div className="home-mobile-list-item-actions">
												{(showEdit || showSignature) && (
													<button
														type="button"
														className="home-mobile-icon-btn"
														onClick={() =>
															openEdit({ dataItem: item } as GridCellProps)
														}
													>
														<img
															src={`/icon/${showSignature
																	? ICON_NAMES.Signature
																	: ICON_NAMES.Edit
																}.svg`}
															alt={showSignature ? t("Signature") : t("Edit")}
														/>
													</button>
												)}
												<button
													type="button"
													className="home-mobile-icon-btn"
													onClick={() =>
														openPdf({ dataItem: item } as GridCellProps)
													}
												>
													<img
														src={`/icon/${ICON_NAMES.Download}.svg`}
														alt={t("Download")}
													/>
												</button>
											</div>
										</div>
									);
								})}
							</div>
						) : (
							<Grid
								style={{ height: "auto" }}
								rowHeight={38}
								rows={{ data: (row) => CustomRowRender(row) }}
								data={gridData}
								className={
									styles.tableColgroupColFirstChild + " custom_detail_grid"
								}
							>
								{gridColumnFrontItemsHandler().map((column, key) => (
									<GridColumn key={key} {...column} className="no-border" />
								))}

								<GridColumn
									{...lastColWithBtn({
										width: "150px",
										showDetails: false,
										items: [
											...(pageAccess?.update
												? [
													{
														iconName: ICON_NAMES.Upload,
														title: t("UploadNoteFile"),
														conditionField: "noteStatusId",
														showConditionValue: 1,
														onclick: upload,
													},
													{
														iconName: ICON_NAMES.Edit,
														title: t("EditNote"),
														conditionField: "noteStatusId",
														showConditionValue: 1,
														onclick: openEdit,
													},
													{
														iconName: ICON_NAMES.Edit,
														title: t("EditNote"),
														conditionField: "noteStatusId",
														showConditionValue: 2,
														onclick: openEdit,
													},
													{
														iconName: ICON_NAMES.Signature,
														title: t("SignNote"),
														conditionField: "noteStatusId",
														showConditionValue: 4,
														onclick: openEdit,
													},
													{
														iconName: ICON_NAMES.Download,
														title: t("DownloadPdf"),
														alwaysShow: true,
														onclick: openPdf,
													},
												]
												: [
													{
														iconName: ICON_NAMES.Download,
														title: t("DownloadPdf"),
														alwaysShow: true,
														onclick: openPdf,
													},
												]),
										],
										showDelete: false,
									})}
								/>
							</Grid>
						)}
					</div>
				</CardBody>
			</Card>
		</div>
	);
}

export default LandingNoteCard;
